module.exports = __webpack_public_path__ + "static/img/home3.415ba50.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/home3.jpg
// module id = lchM
// module chunks = 128